// extracted by mini-css-extract-plugin
export default {"_":"Tumbler____Kfwpq","_link":"Tumbler__link__wOkAd","_text":"Tumbler__text__PTBOc","active":"Tumbler_active__9mWB+","disabled":"Tumbler_disabled__qhZli"};